import React from "react";
import { secondary } from "./recipeStyles";
interface Props {
  loading: boolean;
  error: string;
  conflict: boolean;
  saving: boolean;
  reload: () => void;
  notice: string;
  loaded: boolean;
  load: (force?: boolean) => Promise<void>;
}
export default function RecipeMessages({
  loading,
  error,
  conflict,
  saving,
  reload,
  notice,
  loaded,
  load,
}: Props) {
  return (
    <>
      {loading && (
        <p role="status" className="pb-4 text-sm text-slate-500">
          Loading recipe…
        </p>
      )}
      {error && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2.5">
          <p role="alert" className="text-sm text-red-800">
            {error}
          </p>
          {conflict && (
            <button
              type="button"
              onClick={reload}
              disabled={saving || loading}
              className={`${secondary} mt-2 bg-white`}
            >
              Reload saved recipe
            </button>
          )}
        </div>
      )}
      {notice && (
        <p role="status" className="text-xs text-slate-500">
          {notice}
        </p>
      )}
      {!loaded && !loading && (
        <button
          type="button"
          className={`${secondary} mb-4`}
          onClick={() => void load(true)}
        >
          Retry loading recipe
        </button>
      )}
    </>
  );
}
